import Home from "./Pages/Home";

import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
// import { useCookies } from "react-cookie";
import { HelmetProvider } from "react-helmet-async";
import Products from "./Pages/Products";
import AboutUs from "./Pages/AboutUs";
import "./Assets/Font/Cygre-Bold-700.ttf";
import "./Assets/Font/Cygre-Book-350.ttf";
import "./Assets/Font/Cygre-Light-300.ttf";
import "./Assets/Font/Cygre-Medium-500.ttf";
import "./Assets/Font/Cygre-SemiBold-600.ttf";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/about-us",
    element: <AboutUs />,
  },

  {
    path: "*",
    element: <Navigate to={"/"} />,
  },
]);

function App() {
  return (
    <>
      <HelmetProvider>
        <RouterProvider router={router} />
      </HelmetProvider>
    </>
  );
}

export default App;
